import NexusLogoImg from "@/assets/nexus.png";
import { LogoImage, LogoProps } from "../LogoImage";

type Props = Omit<LogoProps, "imgSrc" | "alt">;

export const NexusLogo = (props: Props) => (
  <LogoImage imgSrc={NexusLogoImg} alt="Nexus Logo" size="navbar" {...props} />
);
